var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-alert',{attrs:{"variant":"danger","dismissible":false}},[_c('gl-sprintf',{attrs:{"message":_vm.error},scopedSlots:_vm._u([{key:"wikiLink",fn:function({ content }){return [_c('gl-link',{attrs:{"href":_vm.wikiPagePath,"target":"_blank"}},[_vm._v(_vm._s(content))])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }